import { render, staticRenderFns } from "./AdminLanding.vue?vue&type=template&id=55622770&"
import script from "./AdminLanding.vue?vue&type=script&lang=js&"
export * from "./AdminLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports